import { useEffect, useRef } from 'react';

import { useLLMActionRegistryContext } from '../llm-action-registry/llm-action-registry-context';
import type { BindOptions, ExecuteCallback, TriggerCallback } from '../llm-action-registry/types';

export const useLLMActionBinding = (actionId: string | null, callback: ExecuteCallback | TriggerCallback, options: BindOptions) => {
  const registry = useLLMActionRegistryContext();
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  const { slot } = options;

  useEffect(() => {
    if (!actionId) return;

    registry.bindAction(actionId, (params) => callbackRef.current(params), slot);
    return () => registry.unbindAction(actionId, slot);
  }, [registry, actionId, slot]);
};
